import { makeStyles } from '@material-ui/core/styles';

export const useDetailStyles = makeStyles((theme) => ({
    licenseWarning: {
        fontWeight: 'bold',
        color: theme.palette.status.red,
    },
    singleSEM: {
        width: '220px',
    },
}));
